"use client";

import PropTypes from "prop-types";

import Modal from "src/components/common/responsiveModal";
import MapTab from "src/components/listing-detail/info-modal-tabs/map-tab";

import styles from "./styles.module.css";

const ShowProjectOnMap = ({ isOpen, onClose, title, location, projectId }) => {
  return (
    <>
      {isOpen && (
        <Modal isOpen={isOpen} onClose={onClose} title={title} size="large">
          <div className={styles.mapWrapper}>
            <MapTab location={location} listingId={projectId} useSatellite />
          </div>
        </Modal>
      )}
    </>
  );
};

ShowProjectOnMap.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  location: PropTypes.shape({
    coordinate: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lon: PropTypes.number.isRequired,
    }),
    geoShape: PropTypes.arrayOf(
      PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lon: PropTypes.number.isRequired,
      })
    ),
  }).isRequired,
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ShowProjectOnMap;
